import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const PAYMENT_API_URL = `${API_HOST}/api/payment`;
const PAYMENT_INIT_API_URL = `${PAYMENT_API_URL}/init`;

const THIRD_PARTY_ORDER_CREATE_API_URL = `${API_HOST}/third_party_order/create`;
const THIRD_PARTY_ORDER_API_URL = `${PAYMENT_API_URL}/thirdPartyOrder`;
const THIRD_PARTY_ORDER_EXTERNAL_METAS = `${PAYMENT_API_URL}/thirdPartyOrder/external_metas`;

function* createThirdPartyOrder() {
  yield takeEvery(actions.CREATE_THIRD_PARTY_ORDER, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${THIRD_PARTY_ORDER_CREATE_API_URL}`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_THIRD_PARTY_ORDER_ENDED });
    }
  });
}

function* getThirdPartyOrder() {
  yield takeEvery(actions.GET_THIRD_PARTY_ORDER, function* (action) {
    const { parameters, onSuccess } = action;

    try {
      const res = yield call(
        [axios, 'get'],
        `${THIRD_PARTY_ORDER_API_URL}?${parameters.toString()}`,
      );

      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.GET_THIRD_PARTY_ORDER_ENDED });
    }
  });
}

function* getThirdPartyOrderTransactions() {
  yield takeEvery(actions.GET_THIRD_PARTY_ORDER_TRANSACTIONS, function* (action) {
    const { parameters, onSuccess, id } = action;

    try {
      const res = yield call(
        [axios, 'get'],
        `${THIRD_PARTY_ORDER_API_URL}/${id}/transactions?${parameters.toString()}`,
      );

      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.GET_THIRD_PARTY_ORDER_TRANSACTIONS_ENDED });
    }
  });
}

function* refundThirdPartyOrder() {
  yield takeEvery(actions.REFUND_THIRD_PARTY_ORDER, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${THIRD_PARTY_ORDER_API_URL}/${id}/refund`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
      yield call(onSuccess, {});
    } finally {
      yield put({ type: actions.REFUND_THIRD_PARTY_ORDER_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createThirdPartyOrder),
    fork(getThirdPartyOrder),
    fork(getThirdPartyOrderTransactions),
    fork(refundThirdPartyOrder),
  ]);
}
